import React, { useEffect, useRef, useState } from "react";

import API from "../../../api";
import Button from "../../../components/button";
import TextInputField from "../../../components/textInput";
import { useLanguage } from '@languages/index';


export default {
    buildBackwardText: (onClick:any) => {
      const language = useLanguage();   
      const languageTexts = { ...language.common, ...language.pages.sns };
          return (
          <div
            className="cursor-pointer"
            onClick={(e) => (onClick)? onClick(e): null}
          >
            <div className="flex flex-row justify-left">
              <img src="/assets/icons/ic-chevron-left-black.svg" />
              <span className="ml-[10px] font-bold text-[22px]">{languageTexts.button_prev_2}</span>
            </div>
          </div>
      );
    },
    buildTitle: (title:string) => {
      return (
          <div className="self-start font-bold text-[16px] text-[#000000]">
            {title}
          </div>
      );
    },
    buildTextInput: (placeholder:string, stateArr:any, disabled:boolean=false) => {
      return (
          <div className="form-input">
            <TextInputField
              bordered
              width="335px"
              value={stateArr[0]}
              placeholder={placeholder}
              onChangeText={(value) => {
                stateArr[1](value);
              }}
              disabled={disabled}
            />
          </div>
      );
    },


}
